import { useMutation, useQuery } from '@apollo/client/react';
import { Button, Checkbox, Form, Input, Modal, Row, Table, Typography, message as antdMessage } from 'antd';
import dayjs from 'dayjs';
import { useState } from 'react';
import styled from 'styled-components';

import { Spacer } from '../../components/Spacer';
import { CREATE_PUSH_NOTIFICATION, PUSH_NOTIFICATIONS } from '../../gqls/push-notification';

const TAKE = 30;

export const PagePushNotifications = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [createPushNotificationModalVisible, setCreatePushNotificationModalVisible] = useState(false);
  const [message, setMessage] = useState('');
  const [typeUsersChecked, setTypeUsersChecked] = useState(false);
  const [typeExecutorsChecked, setTypeExecutorsChecked] = useState(false);

  const { data, loading, refetch } = useQuery(PUSH_NOTIFICATIONS);

  const pushNotifications = data?.pushNotifications || [];
  const pushNotificationsCount = data?.pushNotificationsCount || 0;

  const [messageApi, contextHolder] = antdMessage.useMessage();

  const [createPushNotification, { loading: createPushNotificationLoading }] = useMutation(CREATE_PUSH_NOTIFICATION, {
    onCompleted: () => {
      messageApi.success('Push-уведомление отправлено');
    },
    onError: (err) => {
      console.error(err);
      messageApi.error('Произошла ошибка, повторите еще раз');
    },
  });

  const handleCreatePushNotification = () => {
    let type = 'all';
    if (typeUsersChecked && !typeExecutorsChecked) type = 'users';
    if (!typeUsersChecked && typeExecutorsChecked) type = 'executors';
    createPushNotification({ variables: { data: { message, type } } }).finally(() => {
      refetch();
      setCreatePushNotificationModalVisible(false);
    });
  };

  return (
    <>
      {contextHolder}
      <Row justify="space-between">
        <Typography.Title level={5} style={{ margin: 0 }}>
          Push-уведомления ({pushNotificationsCount})
        </Typography.Title>
        <Button onClick={() => setCreatePushNotificationModalVisible(true)}>Отправить Push-уведомление</Button>
      </Row>
      <Spacer h={12} />
      <ContentTable>
        <Table
          size="middle"
          loading={loading}
          dataSource={pushNotifications}
          columns={[
            {
              key: 'createdAt',
              dataIndex: 'createdAt',
              title: 'Дата создания',
              render: (date) => dayjs(date).format('DD.MM.YYYY HH:mm'),
            },
            {
              key: 'message',
              dataIndex: 'message',
              title: 'Текст',
            },
            {
              key: 'type',
              dataIndex: 'type',
              title: 'Получатели',
              render: (type) => (type === 'users' ? 'Все заказчики' : type === 'executors' ? 'Все исполнители' : 'Все'),
            },
          ]}
          pagination={{
            current: currentPage,
            total: pushNotificationsCount,
            pageSize: TAKE,
            onChange: (page) => {
              setCurrentPage(page);
            },
          }}
        />
      </ContentTable>
      <Modal
        title="Отправить Push-уведомление"
        open={createPushNotificationModalVisible}
        onCancel={() => setCreatePushNotificationModalVisible(false)}
        footer={
          <>
            <Button type="default" onClick={() => setCreatePushNotificationModalVisible(false)}>
              Отмена
            </Button>
            <Button
              type="primary"
              onClick={handleCreatePushNotification}
              disabled={!typeUsersChecked && !typeExecutorsChecked}
              loading={createPushNotificationLoading}
            >
              Отправить
            </Button>
          </>
        }
      >
        <Form.Item label="Сообщение" required layout="vertical">
          <Input value={message} onChange={(e) => setMessage(e.target.value)} style={{ width: '100%' }} />
        </Form.Item>
        <Checkbox checked={typeUsersChecked} onChange={(e) => setTypeUsersChecked(e.target.checked)}>
          Все заказчики
        </Checkbox>
        <br />
        <Checkbox checked={typeExecutorsChecked} onChange={(e) => setTypeExecutorsChecked(e.target.checked)}>
          Все исполнители
        </Checkbox>
      </Modal>
    </>
  );
};

const ContentTable = styled.div`
  overflow-x: auto;

  table {
    min-width: 1100px;
  }
`;
